import api from './api';
import { Consultation, ConsultationItem, ConsultationHistoryItem } from '../types';

export interface CreateConsultationData {
  items: ConsultationItem[];
  notes?: string;
  customerData: {
    name: string;
    email: string;
    phone: string;
  };
}

export const consultationService = {
  createConsultation: async (data: CreateConsultationData) => {
    const response = await api.post('/consultations', data);
    return response.data;
  },

  getConsultations: async (): Promise<Consultation[]> => {
    const response = await api.get('/consultations');
    return response.data;
  },

  getUserConsultations: async (): Promise<ConsultationHistoryItem[]> => {
    const response = await api.get('/consultations/user');
    return response.data;
  },

  getConsultation: async (id: string): Promise<Consultation> => {
    const response = await api.get(`/consultations/${id}`);
    return response.data;
  },

  updateConsultationStatus: async (id: string, status: string) => {
    const response = await api.put(`/consultations/${id}/status`, { status });
    return response.data;
  },
};